<template>
  <div class="mx-auto max-w-6xl px-6">
    <slot />
  </div>
</template>
